import { useState } from 'react';

export function useTemplateState() {
  const [showTemplates, setShowTemplates] = useState(false);
  const [templateTagFilter, setTemplateTagFilter] = useState('#all');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [exerciseInput, setExerciseInput] = useState("");
  const [exerciseLoading, setExerciseLoading] = useState(false);
  const [exerciseResult, setExerciseResult] = useState("");
  const [showExerciseInput, setShowExerciseInput] = useState(false);
  const [showExerciseResult, setShowExerciseResult] = useState(false);
  const [pdfModal, setPdfModal] = useState(null);
  const [materialsSelectorModal, setMaterialsSelectorModal] = useState(false);

  return {
    showTemplates, setShowTemplates,
    templateTagFilter, setTemplateTagFilter,
    selectedTemplate, setSelectedTemplate,
    exerciseInput, setExerciseInput,
    exerciseLoading, setExerciseLoading,
    exerciseResult, setExerciseResult,
    showExerciseInput, setShowExerciseInput,
    showExerciseResult, setShowExerciseResult,
    pdfModal, setPdfModal,
    materialsSelectorModal, setMaterialsSelectorModal,
  };
}
